







































import {
    Prop,
    Component,
    Vue,
    Inject,
    InjectReactive,
} from "vue-property-decorator";
import AbcStepButtons from "./AbcStepButtons.vue";

@Component({
    components: {
        AbcStepButtons,
    },
})
export default class AbcStep extends Vue {
    @Prop({ required: true }) step!: number;
    @Prop({ type: Boolean }) isDisabled!: boolean;
    @Prop({ type: Boolean }) isOptional!: boolean;
    @Prop({type: Boolean}) isComplete!: boolean;
 
    @Inject() changeStep!: (step: number) => void;
    @InjectReactive() curStep!: number;
    @InjectReactive() isVertical!: boolean;
    @InjectReactive() numberOfSteps!: number;

    private onClick() {
        if (!this.isDisabled && this.isCompleted) {
            this.changeStep(this.step);
        }
    }

    private get hasIconSlot(){
        return this.$slots.icon;
    }

    get isCompleted(){
        if(this.isComplete) {
            return true;
        }
        if(this.step < this.curStep){
            return true;
        } else {
            return false;
        }
    }

    private get stepClass() {
        const current = this.curStep == this.step;
        return {
            "active": current,
            "success": this.isCompleted,
            "disabled": this.isDisabled && this.isCompleted,
            "optional": this.isOptional,
            "clickable": !this.isDisabled && this.isCompleted,
        };
    }
}
